import type React from 'react';
import type { RecentlyViewedItem } from '../../Store/RecentlyViewedItem/state';
import Translation from '../../../general/Translation/Translation';
import ProductBox from '../../../general/ProductBox/ProductBox';
import Section from '../../../general/Section/Section';

interface RecentlyViewedContainerProps {
    products: RecentlyViewedItem[];
}

const RecentlyViewedContainer: React.FC<RecentlyViewedContainerProps> = ({ products }) => (
    <Section isXl hasWaveTop>
        <div className="content">
            <h2><Translation pageString="snippet.nieuwe_cadeaus_carousel" stringId="eerder_bekeken" /></h2>
        </div>
        <div className="product-list is-grid has-col-4-xl has-col-3-md has-col-2 has-row-gap-md">
            {products.map((product) => (
                <ProductBox
                    key={product.title}
                    href={product.url}
                    image={product.image}
                    price={product.priceRegular}
                    priceFrom={product.priceFrom}
                    title={product.title}
                    hasFreeCoolerNotification={false}
                />
            ))}
        </div>
    </Section>
);

export default RecentlyViewedContainer;
